import React from 'react'
import LabelTemplate, { statusList, unkownStatus } from '../LabelTemplate'

// eslint-disable-next-line react/prop-types
export default function StatusTemplate ({ status }) {
  const foundStatus = statusList.find(s => s.text === status) || unkownStatus
  return <LabelTemplate text={foundStatus.text} color={foundStatus.color} />
}
